module.exports = __webpack_public_path__ + "img/carousel-vet-8.1cce807f.jpg";